import React, { useState } from 'react';
// import PurpleBtn from '../components/btns/PurpleBtn';
import MovieSvg from '../assets/svg/MovieSvg';
import CarSvg from '../assets/svg/CarSvg';
import LocationSvg from '../assets/svg/LocationSvg';
import TimeSvg from '../assets/svg/TimeSvg';
import DateSvg from '../assets/svg/DateSvg';
import jokerPoster from '../assets/img/jokerPoster.webp';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const FormPage = () => {
  const { state } = useLocation();
  const { img, title, time, date, centers } = state || {};

  const [selection] = useState('car');
  const [carCount] = useState(1);
  const [carNumbers, setCarNumbers] = useState(['']);
  const [personCount] = useState(1);
  // const [name] = useState('');
  // const [surname] = useState('');

  const [formData, setFormData] = useState({
    name: "",
    car_number: "",
    movie: { title },
    time: { time },
    date: { date },
  });

  const [responseMessage, setResponseMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post("http://localhost:4000/buyers", formData);
      setResponseMessage("Данные успешно отправлены!");
      console.log(response.data);
    } catch (error) {
      console.error(error);
      setResponseMessage("Ошибка при отправке данных.");
    }
  };

  const getPrice = () => {
    if (centers === 'Su İdman Sarayı') {
      return {
        car: 20,
        puff: 10,
      };
    } else if (centers === 'Buzovna') {
      return {
        car: 15,
        puff: 0,
      };
    }
    return {
      car: 20,
      puff: 15,
    };
  };

  const { car: carPrice, puff: puffPrice } = getPrice();
  const totalPrice = selection === 'car' ? carCount * carPrice : personCount * puffPrice;

  // const navigate = useNavigate();

  // const navToPayment = () => {
  //   if (selection === 'car') {
  //     if (carNumbers.some((number) => !number.trim())) {
  //       alert('Zəhmət olmasa bütün avtomobil nömrələrini doldurun.');
  //       return;
  //     }
  //     if (carNumbers.some((number) => number.trim().length !== 7)) {
  //       alert('Hər bir avtomobil nömrəsi 7 simvoldan ibarət olmalıdır.');
  //       return;
  //     }
  //   } else if (selection === 'puffs' && puffPrice > 0) {
  //     if (!name.trim() || !surname.trim()) {
  //       alert('Zəhmət olmasa ad və soyadınızı qeyd edin.');
  //       return;
  //     }
  //   }
  //   navigate('/payment');
  // };

  // const handleCarCountChange = (e) => {
  //   const count = parseInt(e.target.value);
  //   setCarCount(count);
  //   setCarNumbers(Array(count).fill(''));
  // };

  const handleCarNumberChange = (index, value) => {
    const newCarNumbers = [...carNumbers];
    newCarNumbers[index] = value;
    setCarNumbers(newCarNumbers);
  };

  // const handleSelectionChange = (e) => {
  //   setSelection(e.target.value);
  // };

  return (
    <section className="flex justify-center items-center w-full relative">
      <div className="w-[400px]">
        <div
          className="w-full h-[600px] rounded-[12px_12px_0_0] border-t border-l border-r border-purple mt-[32px]"
          style={{ backgroundImage: `url(${img || jokerPoster})`, backgroundSize: 'cover' }}
        ></div>

        <div className="bg-main p-4 rounded-[0_0_12px_12px] flex flex-col gap-4 border-b border-l border-r border-purple mb-[32px]">
          <div className="border border-purple px-4 py-1 flex justify-center gap-2 items-center rounded-[20px] w-full">
            <MovieSvg />
            <input
              type="text"
              name="movie"
              value={formData.movie.title}
              readOnly
              className="bg-none border-none text-white font-semibold"
            />
          </div>
          <div className="border border-purple px-4 py-1 flex justify-center gap-2 items-center rounded-[20px] w-full">
            <LocationSvg />
            <p className="text-white font-semibold">{centers}</p>
          </div>
          <div className="border border-purple px-4 py-1 flex justify-center gap-2 items-center rounded-[20px] w-full">
            <TimeSvg />
            <input
              type="text"
              name="time"
              value={formData.time.time}
              readOnly
              className="w-full border border-gray-300 rounded-md p-2 bg-gray-100 cursor-not-allowed"
            />
          </div>
          <div className="border border-purple px-4 py-1 flex justify-center gap-2 items-center rounded-[20px] w-full">
            <DateSvg />
            <input
              type="text"
              name="date"
              value={formData.date.date}
              readOnly
              className="w-full border border-gray-300 rounded-md p-2 bg-gray-100 cursor-not-allowed"
            />
          </div>

          {selection === 'car' && (
            <>
              {carNumbers.map((carNumber, index) => (
                <div key={index}>
                  <div className="border border-purple px-4 py-1 flex justify-center gap-2 items-center rounded-[20px] w-full">
                    <CarSvg />
                    <input
                      type="text"
                      name="car_number"
                      placeholder="Qeydiyyat Nişanı"
                      value={carNumbers[index]}
                      onChange={(e) => handleCarNumberChange(index, e.target.value)}
                      className="bg-main border-main outline-none text-white font-semibold w-[150px]"
                      required
                    />
                  </div>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-md p-2"
                    required
                  />
                </div>
              ))}
            </>
          )}

          {selection === 'puffs' && puffPrice > 0 && (
            <>
              <div className="border border-purple px-4 py-1 flex justify-center gap-2 items-center rounded-[20px] w-full">
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-md p-2"
                  required
                />
              </div>
              <div className="border border-purple px-4 py-1 flex justify-center gap-2 items-center rounded-[20px] w-full">
                <input
                  type="text"
                  name="surname"
                  value={formData.surname}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-md p-2"
                  required
                />
              </div>
            </>
          )}

          <div className="text-white font-semibold text-center">
            Məbləğ: {totalPrice} AZN
          </div>

          <form onSubmit={handleSubmit}>
            {/* Form fields go here */}
            <button
              type="submit"
              className="w-full bg-blue-500 text-purple font-bold py-2 rounded-md hover:bg-blue-600"
            >
              Отправить
            </button>
          </form>

          {responseMessage && (
            <p className="text-center mt-4 text-green-600">{responseMessage}</p>
          )}
        </div>
      </div>
    </section>
  );
};

export default FormPage;
